// extracted by mini-css-extract-plugin
module.exports = {"collapseLabel":"SideToolbarCollapsible_collapseLabel__qxzqQ","collapseTrigger":"SideToolbarCollapsible_collapseTrigger__Q4Rit"};